"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_core_1 = require("@statsig/client-core");
function _parseResponse(values) {
    return (0, client_core_1._typedJsonParse)(values, 'has_updates', 'DownloadConfigSpecsResponse');
}
class SpecStore {
    constructor() {
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
    }
    getValues() {
        return this._rawValues ? _parseResponse(this._rawValues) : null;
    }
    setValuesFromDataAdapter(result) {
        if (!result) {
            return;
        }
        const values = _parseResponse(result.data);
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) {
            return;
        }
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._source = result.source;
        this._values = values;
        this._rawValues = result.data;
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
    }
    finalize() {
        if (this._values) {
            return;
        }
        this._source = 'NoValues';
    }
    getSpecAndSourceInfo(kind, name) {
        var _a;
        // todo: use Object instead of Array
        const specs = this._getSpecs(kind);
        return {
            spec: (_a = specs === null || specs === void 0 ? void 0 : specs.find((spec) => spec.name === name)) !== null && _a !== void 0 ? _a : null,
            source: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt,
        };
    }
    _getSpecs(kind) {
        var _a, _b, _c;
        switch (kind) {
            case 'gate':
                return (_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates;
            case 'config':
                return (_b = this._values) === null || _b === void 0 ? void 0 : _b.dynamic_configs;
            case 'layer':
                return (_c = this._values) === null || _c === void 0 ? void 0 : _c.layer_configs;
        }
    }
}
exports.default = SpecStore;
